export
const name: string = "Lighting";

export
const preproc: string = ``;

export
const declaration: string = `
    // be careful when working with structures, because on some mobile devices it is not possible to write to any structure

    // the light related code was inspired by http://www.john-chapman.net/content.php?id=3
    struct SLight {
              vec4 position; // in view space when the w component is zero, we have directional light
        lowp  vec3 diffuse;
        lowp  vec3 specular;
        lowp  float enabled;
        lowp  float fixed_pos;
    };

    const      int    MAX_LIGHT_SOURCES = 2;

    // required uniforms
    uniform       int    u_ambient_is_diffuse;
    uniform       float  u_minimal_diffuse_light; // for shadow volumes
    uniform       float  u_ambient_light_intensity;
    uniform       int    u_lights_count;
    uniform       SLight u_lights[MAX_LIGHT_SOURCES];

    // Global variables
    vec3 gAmbient;
    vec3 gDiffuse;
    vec3 gSpecular;
    float gAlpha;

    // Control exposure with this value.
    float exposure;
    // How much bloom to add.
    float bloom;
    // Max bright.
    float bright;

    // TB sunlight color
    // uniform sampler2D   u_sun_color_texture;
    //float sunLookUp;
`;

export
const varyings: string = `
    varying vec3    v_normal;
    varying vec3    v_normal_not_rotated;
    varying vec4    v_position;
`;

export
const implementation: string = `
    //vec4 getSunColor(float x)
    //{
    //    vec4 color = texture2D(u_sun_color_texture, vec2(x, 0.5));
    //    return color;
    //}

    void directional(
        const in SMaterial aSurfaceMaterial,
        const in SLight aLight,
        const in vec3 aSurfaceViewNormal,
        const in vec4 aFragmentViewPosition)
    {
        //	get direction to light:
    	vec3 light_direction = normalize(aLight.position.xyz);

        //	accumulate diffuse:
    	float n_dot_l;
    	if (aSurfaceMaterial.two_sided_lighting == 0) {
    	    // one sided lighting
    		n_dot_l = dot(aSurfaceViewNormal, light_direction);
    	}
    	else {
    	    // this is two sided lighting i.e. the direction of the dot product does not matter
    		n_dot_l = abs(dot(aSurfaceViewNormal, light_direction));
    	}

    	gDiffuse += aLight.diffuse * max(u_minimal_diffuse_light, n_dot_l);

    	if (n_dot_l > 0.0 && aSurfaceMaterial.shininess > 0.000001) { // if fragment is illuminated
    		//	accumulate specular:
    		vec3 view_direction = normalize(aFragmentViewPosition.xyz);
    		vec3 reflection = reflect(light_direction, aSurfaceViewNormal);
    		float spec = max(0.0, dot(reflection, view_direction));
            gSpecular += aLight.specular * pow(spec, aSurfaceMaterial.shininess * 100.0);
    	}
    }

    /**
     * aNormal ... modification for normal mapping
     */
    void prepareLighting(const SMaterial aSurfaceMaterial, vec3 aNormal)
    {
        // when the ambient equals diffuse color uniform is enabled, then instead of using the surface ambient color, we use the diffuse color
        vec3 ambientSurfaceColor = aSurfaceMaterial.ambient;
        if (u_ambient_is_diffuse == 1) {
             ambientSurfaceColor = aSurfaceMaterial.diffuse;
        }

        vec3 normalNotRotated = v_normal_not_rotated * aNormal;
        vec3 normal = v_normal * aNormal;
        gDiffuse  = vec3(0.0);
        gSpecular = vec3(0.0);

        for (int i = 0; i < MAX_LIGHT_SOURCES; i++) {
            if (i < u_lights_count) {
                if (u_lights[i].enabled > 0.5) {
                    if (u_lights[i].position.w > 0.5) {
                        /*if (u_lights[i].spot_exponent != 0.0) { // spot light
                            spot(surface, u_lights[i], results);
                        }
                        else { // point light
                            point(surface, u_lights[i], results);
                        }*/
                    }
                    else { //w == 0.0 -> directional light
                        if (aSurfaceMaterial.shading == 1) {
                            if (u_lights[i].fixed_pos > 0.5) {
                                directional(aSurfaceMaterial, u_lights[i], normalNotRotated, v_position);
                            }
                            else {
                                directional(aSurfaceMaterial, u_lights[i], normal, v_position);
                            }
                        }
                        else
                        {
                            gDiffuse  += u_lights[i].diffuse;
                            gSpecular += u_lights[i].specular;
                        }
                    }
                }
            }
        }

        gDiffuse *= aSurfaceMaterial.diffuse;
        gSpecular *= aSurfaceMaterial.specular;
        gAmbient = ambientSurfaceColor * u_ambient_light_intensity;
        gAlpha = aSurfaceMaterial.alpha * (1.0 - aSurfaceMaterial.transparency);
    }

    /**
     * Default lighting
     */
    lowp vec4 applyLighting(const SMaterial aSurfaceMaterial)
    {
        prepareLighting(aSurfaceMaterial, vec3(1.0));

    // Apply Ambient Occlusion
    #ifdef SSAO
        float ssao = vec4ToFloat(texture2D(u_ssao_texture, toViewCoords((v_clip_space_position.xy / v_clip_space_position.w) * 0.5 + 0.5, u_view)));
    #else
        float ssao = 1.0;
    #endif

    // Apply Shadow Maps
    #if defined(SHADOW_MAP) || defined(SHADOW_MAP_VARIANCE)
        float shadow = getShadow() * gAlpha;
    #else
        float shadow = 1.0;
    #endif

        vec4 finalColor = vec4((gAmbient + (gDiffuse + gSpecular) * shadow) * ssao, gAlpha);

    #ifdef FOG
        finalColor.rgb = applyFog(finalColor.rgb);
    #endif

    /*
    // Control exposure with this value.
    float exposure = 2.5;
    // How much bloom to add.
    float bloom = 10.0;
    // Max bright.
    float bright = 1.2;



    // Perform tone-mapping.
        float Y = dot(vec4(0.30, 0.59, 0.11, 0.0), finalColor);
        float YD = exposure * (exposure / bright + 1.0) / (exposure + 1.0);
        finalColor *= YD;
    */


        return finalColor;
    }
`;
